import { useQuery } from '@tanstack/react-query';
import { ScrapejobApiClient } from 'api/scrapejob';
import { ScrapesiteModel } from 'models/scrapejob/ScrapesiteModel';

export function useScrapesites() {
  return useQuery<ScrapesiteModel[]>({
    queryKey: ['scrapesites'],
    queryFn: () => ScrapejobApiClient.getAllScrapesites()
  });
}
